export default __webpack_public_path__ + "static/media/Thumbs.42617255.db";